import { z } from 'zod';
import {
  CommentsReturnSchema,
  CommentReturnSchema,
  CommentCreateSchema,
  CommentUpdateSchema,
  CommentsQuerySchema,
  CommentParamsSchema,
} from './comments.schema';
import { COMMENTS_PATH_NAME } from './comments.constants';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';

export const CommentsContract = terraContract
  .prefix(`/${COMMENTS_PATH_NAME}`)
  .router({
    getComments: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'Get comments for an entity',
        description:
          'Retrieves all comments for a specific entity (application, asset, finding, etc.)',
        inputStructure: 'detailed',
      })
      .input(z.object({ query: CommentsQuerySchema }))
      .output(CommentsReturnSchema),
    createComment: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/',
        summary: 'Create a comment',
        description: 'Creates a new comment on an entity',
        inputStructure: 'detailed',
        successStatus: 201,
      })
      .input(z.object({ body: CommentCreateSchema }))
      .output(CommentReturnSchema),
    updateComment: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'PUT',
        path: '/{commentId}',
        summary: 'Update a comment',
        description: 'Updates an existing comment',
        inputStructure: 'detailed',
      })
      .input(
        z.object({ params: CommentParamsSchema, body: CommentUpdateSchema }),
      )
      .output(CommentReturnSchema),
    deleteComment: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'DELETE',
        path: '/{commentId}',
        summary: 'Delete a comment',
        description: 'Deletes a comment',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: CommentParamsSchema }))
      .output(z.object({ success: z.boolean() })),
  });
